// extracted by mini-css-extract-plugin
export default {"searchHeader":"_2MPEIXUj","searchInputContainer":"CJO7mXC-","searchInput":"_2J9FyVLq","searchIcon":"_2EGqai5J"};